export class ConfirmationCancel {
  public static readonly type = '[Project/Dashboard/List] ConfirmationCancel';
}
